export default __webpack_public_path__ + "static/media/shopee_code_league.96699464.png";